import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as fromShared from '../../../shared';
import { Process } from '../../../shared';
import { EditGrid } from '../../../shared/EditGrid';
import {
    FilterService,
    SelectItem,
    Table
} from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { IUserInfo } from '../../../user-info';
import * as fromStore from '../../management/store';

@Component({
    selector: 'ef-invoice-session-number',
    templateUrl: './invoice-session-number.component.html',
    styleUrls: ['./invoice-session-number.component.scss'],
    standalone: false
})
export class InvoiceSessionNumberComponent
    extends EditGrid<fromStore.SessionNumber.InvoiceSessionNumber>
    implements OnInit, OnChanges
{
    loading = true;
    moment: any;
    dropdownItemHeight = environment.dropdownItemHeight;
    virtualItems: fromStore.SessionNumber.InvoiceSessionNumber[];
    @Input() userInfo: IUserInfo;
    LastInvoiceEnd: Date;
    LastInvoiceStart: Date;
    sessionEndSelectItem: SelectItem[];
    public get contracts(): SelectItem[] {
        if (this.items && this.items.length > 0) {
            return fromShared
                .uniqBy(this.items, x => x.CName)
                .map(x => ({ label: x.CName, value: x.CName }));
        } else {
            return [];
        }
    }
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    rowGroupMetadata: any = {};
    @ViewChild('dtSessionNumber') dataTable: Table;
    startDateFilter: any;
    endDateFilter: any;
    @Input() process: Process;
    @Output() DeleteInvoiceSessions = new ReplaySubject<any>(1);

    displayDeleteDialog = false;
    rowData: fromStore.SessionNumber.InvoiceSessionNumber;
    invoiceDeleteMessage: string;
    constructor(
        private log: LoggingService,
        private filterService: FilterService,
        private cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.items.currentValue) {
            this.updateRowGroupMetaData(changes.items.currentValue);
        }
    }
    ngOnInit() {
        if (this.userInfo) {
            if (
                moment(new Date(this.userInfo.LastInvoiceStart)).isValid() &&
                moment(new Date(this.userInfo.LastInvoiceEnd)).isValid()
            ) {
                this.LastInvoiceStart = new Date(
                    this.userInfo.LastInvoiceStart
                );
                this.LastInvoiceEnd = new Date(this.userInfo.LastInvoiceEnd);
            }
        }

        this.addDateRangeFilter();
        // setTimeout(() => {
        //     this.dataTable.sort({
        //         data: this.items,
        //         field: 'ContractDesc',
        //         mode: 'single',
        //         order: 1
        //     });
        // }, 0);
    }
    onRowEditInit(item) {
        super.onRowEditInit(item);
        let arr = [];
        if (this.items && this.items.length > 0) {
            this.items.forEach(ele => {
                if (ele.ListID == item.ListID) {
                    arr.push(ele);
                }
            });
            arr = arr.filter(
                x => new Date(x.SessionEnd) >= new Date(item.SessionStart)
            );
            this.sessionEndSelectItem = arr.map(x => ({
                value: x.SessionEnd,
                label: x.SessionEnd
            }));
        }
    }
    onRowEditSave(item) {
        const data = {
            ...item,
            VoucherNbr: +item.VoucherNbr
        };
        super.onRowEditSave(data);
    }
    deleteClicked(rowData) {
        this.rowData = rowData;
        this.invoiceDeleteMessage = `This will delete the selected invoice for ${rowData.CName}.`;
        this.displayDeleteDialog = true;
    }
    deleteInvoiceSession() {
        if (this.rowData != null) {
            this.DeleteInvoiceSessions.next([this.rowData.Ib_id]);
            this.rowData = null;
        }
        this.displayDeleteDialog = false;
        this.invoiceDeleteMessage = "";
    }
    updateRowGroupMetaData(data) {
        if (!(data && data.length > 0)) {
            return;
        }
        this.log.verbose({
            type: 'InvoiceSessionNumberComponent:updateRowGroupMetaData',
            data
        });
        // this.loading = true;
        // this.cdRef.markForCheck();
        this.rowGroupMetadata = {};
        if (data) {
            for (let i = 0; i < data.length; i++) {
                const rowData = data[i];
                const field = 'ContractDesc';
                const category = rowData[field];
                if (i === 0) {
                    this.rowGroupMetadata[category] = { index: 0, size: 1 };
                } else {
                    const previousRowData = data[i - 1];
                    const previousRowGroup = previousRowData[field];
                    if (category === previousRowGroup) {
                        this.rowGroupMetadata[category].size++;
                    } else {
                        this.rowGroupMetadata[category] = { index: i, size: 1 };
                    }
                }
            }
            this.log.verbose({
                type: 'InvoiceSessionNumberComponent:updateRowGroupMetaData',
                data,
                rowGroupMetadata: this.rowGroupMetadata
            });
            this.cdRef.markForCheck();
            this.log.verbose({
                type: 'InvoiceSessionNumberComponent:updateRowGroupMetaData:after cdref'
            });
            setTimeout(() => {
                this.loading = false;
                this.log.verbose({
                    type: 'InvoiceSessionNumberComponent:updateRowGroupMetaData:after timeout'
                });
            }, 0);
        }
    }
    onFilter($event) {
        this.log.verbose({
            type: 'InvoiceSessionNumberComponent:onFilter',
            $event
        });
        // setTimeout(() => {
        this.updateRowGroupMetaData($event.filteredValue);
        // }, 50);
    }
    onSort($event: {
        data: fromStore.SessionNumber.InvoiceSessionNumber[];
        field: string;
        mode: string;
        order: number;
    }) {
        this.log.verbose({
            type: 'InvoiceSessionNumberComponent:onSort',
            $event
        });
        setTimeout(() => {
            this.updateRowGroupMetaData(
                this.dataTable.filteredValue || this.dataTable.value
            );
        }, 50);
    }
    addDateRangeFilter() {
        this.filterService.register(
            'startInvoiceSessionDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceSessionNumberComponent:startDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.startDateFilter[0]),
                    moment(this.startDateFilter[1])
                );
                // get the from/start value
            }
        );
        this.filterService.register(
            'endInvoiceSessionDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceSessionNumberComponent:endDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.endDateFilter[0]),
                    moment(this.endDateFilter[1])
                );
                // get the from/start value
            }
        );
    }
}
